export default __webpack_public_path__ + "static/media/turtle.52556037.webp";